module.exports = __webpack_public_path__ + "assets/img/12.dfb3d97f.png";